import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { Link } from "react-router-dom";

const SUPPORT = [
  "Concept development for your project",
  "Material sourcing (stone, timber, plaster, microcement)",
  "Cabinetry integration",
  "TV / AV integration",
  "Fireplace integration",
  "Concealed lighting",
  "Technical coordination",
  "Budget development with transparent line items",
];

export default function ArchitectsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="architects-page">
      <PublicNav/>
      <section className="pt-32 pb-12 px-6 lg:px-12 max-w-4xl mx-auto">
        <div className="overline">For Architects & Designers</div>
        <h1 className="font-serif font-light mt-4" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>
          A quiet specialist partner for your entertainment walls.
        </h1>
        <p className="text-muted-foreground mt-6 leading-relaxed text-lg">
          Luxe Media Walls works alongside architects, interior designers and premium residential builders as a specialist design-and-build partner for the media wall element of your project — freeing your studio to focus on the whole home.
        </p>
      </section>
      <section className="bg-[color:hsl(var(--background-alt))] py-20 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="overline">Studio Support</div>
          <div className="grid md:grid-cols-2 gap-4 mt-6">
            {SUPPORT.map((s) => (
              <div key={s} className="bg-card p-5 border border-border text-sm">· {s}</div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 text-center px-6">
        <Link to="/enquiry?professional=1" data-testid="btn-architects-enquire" className="btn-accent inline-flex" style={{ padding: "16px 28px" }}>Discuss a Project</Link>
      </section>
      <PublicFooter/>
    </div>
  );
}
